export const eScreenMode = {
  START: 'eScreenMode:START',
  GAME: 'eScreenMode:GAME',
  PAYTABLE: 'eScreenMode:PAYTABLE',
  BONUS_GAME: 'eScreenMode:BONUS_GAME',
  POPUP: 'eScreenMode:POPUP',
  SETTINGS: 'eScreenMode:SETTINGS',
  RULES: 'eScreenMode:RULES',
};
